export const normalizeEmail = (value) => String(value || '').trim().toLowerCase();

export function activationFormFromSummary(data) {
  const ownEmail = normalizeEmail(data.profile_email);
  const contactEmail = normalizeEmail(data.parent_email);
  const noOwnEmail = data.activation_login_mode
    ? data.activation_login_mode === 'username'
    : !ownEmail || ownEmail === contactEmail;
  return { noOwnEmail, ownEmail: noOwnEmail ? '' : ownEmail,
    contactEmail: contactEmail || (noOwnEmail ? normalizeEmail(data.activation_email) : '') };
}

export function activationFormDirty(form, data) {
  const saved = activationFormFromSummary(data);
  return form.noOwnEmail !== saved.noOwnEmail
    || normalizeEmail(form.ownEmail) !== saved.ownEmail
    || normalizeEmail(form.contactEmail) !== saved.contactEmail;
}

export function activationProfilePayload(form) {
  const child_email = form.noOwnEmail ? '' : normalizeEmail(form.ownEmail);
  const parent_email = normalizeEmail(form.contactEmail);
  const valid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  if (form.noOwnEmail ? !valid(parent_email) : !valid(child_email)) {
    throw new Error(form.noOwnEmail ? 'Ange förälderns kontaktadress.' : 'Ange spelarens egen e-postadress.');
  }
  if (parent_email && !valid(parent_email)) throw new Error('Ange en giltig kontaktadress.');
  if (child_email && child_email === parent_email) {
    throw new Error('Förälderns kontaktadress ska inte anges som spelarens egen e-post. Välj Ingen egen e-post.');
  }
  return { child_email, parent_email };
}
